import { useExperience } from "../../../../../shared/context/ExperienceContext";
import { Icons } from "../../../../../shared/icons/icons";
import { getContactWhatsAppLink } from "../../../../../shared/config/contact.config";

import {
  contactCopyByMode,
  getContactItems,
  mapSearchUrl,
  trustItems,
} from "./data/contactData";

import ContactHeading from "./components/ContactHeading/ContactHeading";
import ContactCard from "./components/ContactCard/ContactCard";
import ContactMapCard from "./components/ContactMapCard/ContactMapCard";
import ContactTrustBar from "./components/ContactTrustBar/ContactTrustBar";

import "./ContactSection.css";

const contactIconMap = {
  whatsapp: Icons.FaWhatsapp,
  instagram: Icons.FaInstagram,
  email: Icons.Mail,
  address: Icons.MapPin,
};

const trustIconMap = {
  leaf: Icons.Leaf,
  calendar: Icons.Calendar,
  lock: Icons.Lock,
  heart: Icons.Heart,
};

export default function ContactSection() {
  const { mode } = useExperience();
  const content = contactCopyByMode[mode] || contactCopyByMode.all;

  const contactItemsWithIcons = getContactItems(mode).map((item) => ({
    ...item,
    Icon: contactIconMap[item.iconKey],
  }));

  const trustItemsWithIcons = trustItems.map((item) => ({
    ...item,
    Icon: trustIconMap[item.iconKey],
  }));

  const whatsappHref = getContactWhatsAppLink(mode);

  return (
    <section className="contact-section">
      <div className="container">
        <ContactHeading content={content} EyebrowIcon={Icons.Leaf} />

        <div className="contact-section__grid">
          <ContactCard
            content={content}
            contactItems={contactItemsWithIcons}
            HeaderIcon={Icons.FaWhatsapp}
            MainButtonIcon={Icons.Calendar}
            ActionIcon={Icons.ArrowRight}
            whatsappHref={whatsappHref}
          />

          <ContactMapCard
            HeaderIcon={Icons.MapPin}
            FooterIcon={Icons.Clock}
            ActionIcon={Icons.ArrowRight}
            mapSearchUrl={mapSearchUrl}
          />
        </div>

        <ContactTrustBar items={trustItemsWithIcons} />
      </div>
    </section>
  );
}